import { useCallback, useEffect, useState } from "react";
import { api, errMsg } from "@/lib/api";

export function useApi(url, params) {
  const key = JSON.stringify(params || {});
  const [state, setState] = useState({ data: null, loading: true, error: null });

  const load = useCallback(async () => {
    setState((s) => ({ ...s, loading: true, error: null }));
    try {
      const { data } = await api.get(url, { params: JSON.parse(key) });
      setState({ data, loading: false, error: null });
    } catch (e) {
      setState({ data: null, loading: false, error: errMsg(e) });
    }
  }, [url, key]);

  useEffect(() => { load(); }, [load]);
  return { ...state, reload: load };
}
